import { ModelBase } from "@shoothill/core";
import { makeObservable, observable } from "mobx";

export class SessionDocumentModel extends ModelBase<SessionDocumentModel> {
    public studentSessionId: string | null = null;
    public documentCategoryId: string = "";
    public fileName: string = "";
    public fileSize: number = 0;
    public fileUrl: string = "";
    public documentCategoryName: string = "";
    public createdByFirstName: string = "";
    public createdByLastName: string = "";

    constructor() {
        super();
        makeObservable(this, {
            documentCategoryId: observable,
            fileName: observable,
            fileSize: observable,
            fileUrl: observable,
            documentCategoryName: observable,
        });
    }
}
